<template>
  <div class="manuAssign">
    <template v-if="$route.name ==='CandidateIPAnalysis'">
      <ots-main-title></ots-main-title>
      <ots-table-group-new
        :selectList="selectList"
        :requestForm="requestForm"
        :tableHeader="tableHeader"
        :tableData="tableData"
        @search="search"
      >
      </ots-table-group-new>
    </template>
    <template v-else>
      <ots-main-title></ots-main-title>
      <router-view />
    </template>
  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import {
  getIpAnalysisFn,
  getIpAnalysisPlaceAPI,
  getIpAnalysisSessionAPI,
  getIpAnalysisClassAPI
} from "@/http/modules/examSet/section";

export default {
  data() {
    return {
      // 查询表单
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "考点",
          type: "select",
          requestKey: "placeId",
          label: "name",
          value: "id",
          data: [{ id: "", name: "全部" }],
        },
        {
          title: "场次名称",
          type: "select",
          requestKey: "sessionId",
          label: "name",
          value: "id",
          data: [{ id: "", name: "全部" }],
        },
        {
          title: "教室",
          type: "select",
          requestKey: "classId",
          label: "name",
          value: "id",
          data: [{ id: "", name: "全部" }],
        },
      ],
      /* ** 请求参数 ** */
      requestForm: {
        planId: "",
        placeId: "",
        sessionId: "",
        classId: "",
        page: 1,
        size: 10,
      },
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "场次",
          prop: "sessionName",
        },
        {
          title: "教室",
          prop: "className",
        },
        {
          title: "IP",
          prop: "sourceIp",
        },
        {
          title: "人次",
          type: 'button',                      
          prop: "intCount",
          formatter:(val) => val.row.intCount == 0 ? '0' :val.row.intCount,
          sableFn:(val) => val.row.intCount >= 1 ? true :false,
          click:this.viewDetails,
          align:"right"
        },
      ],
      tableData: [],
    
    };
  },
  watch: {
    "requestForm.planId":function(val){
      this.initSiteData(val)
      this.getChainSession()
      this.getChainClass()
      this.search()
    },
    "requestForm.placeId":function(val){
      this.getChainSession(val)
      this.getChainClass()
      if (val) {
        this.search()
      }
    },
    "requestForm.sessionId": function(val) {
      this.getChainClass(val)
      if (val) {
        this.search();
      }
    },
    "requestForm.classId": function(val) {
      if (val) {
        this.search()
      }
    }

    },
  
  mounted() {
    this.initData();
  },
  methods: {
    /**
     * @param { 获取批次 }
     */
    async initData() {
      let { data } = await getSelectPlanFn({ needAudit: 6 });
      this.$set(this.selectList[0], "data", data);
      if (data.length) {
        this.requestForm.planId = data[0].id;
      }
    },

    /**
     * @param { 获取考点 }
     */

    initSiteData(val) {
      this.requestForm.placeId = ''
      this.requestForm.sessionId = ''
      this.requestForm.classId = ''
      getIpAnalysisPlaceAPI({ planId: val }).then((data) => {
        if(data.data){
          let placeIds = [{ id: "", name: "全部" }, ...data.data];
          this.$set(this.selectList[1], "data", placeIds);
        }else{
          this.$set(this.selectList[1], "data", [{ id: "", name: "全部" }]);
        }
      });
    },

    /**
     * @param { 获取场次 }
     */
    getChainSession(val) {
      this.requestForm.sessionId = ''
      this.requestForm.classId = ''
      let params = {
        planId: this.requestForm.planId,
        placeId: val,
      };
      getIpAnalysisSessionAPI(params).then((res) => {
        if(res.data){
          let sessionId = [{ id: "", name: "全部" }, ...res.data];
        this.$set(this.selectList[2], "data", sessionId);
        }else{
          this.requestForm.sessionId = ''
          this.$set(this.selectList[2], "data", [{ id: "", name: "全部" }]);
        }
      });
    },

    /**
     * @param { 获取教室 }
     */
    async getChainClass(val) {
      this.requestForm.classId = ''
      const { planId, placeId, sessionId } = this.requestForm
      let param = { planId, placeId, sessionId }
      const { data } = await getIpAnalysisClassAPI(param)
      let classId =  [{ id: "", name: "全部" }, ...data]
      this.$set(this.selectList[3], "data", classId)
    },

    /**
     * @param { 查询表格 }
     */
    async search() {
      let params = { ...this.requestForm }
      const { data } = await getIpAnalysisFn(params)
      this.tableData = data
    },

    viewDetails(row){
      this.$router.push({
        name :'CandidateIPAnalysisDetails',
        query:{
          planClassId:row.planClassId,
          sourceIp:row.sourceIp
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
</style>